import styled from 'styled-components'

import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px 16px 0 16px;

  overflow-y: auto;

  @media (min-width: 768px) {
    padding: 0;

    form {
      padding: 0 100px;
    }
  }
`

export const CardsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 32px 0 64px 0;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 32px;
  }
`

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`

export const GoForwardButton = styled.button`
  width: 100%;
  padding: 24px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
  background-color: ${theme.colors.green2};
  border-radius: ${theme.border.mediumRadius};
`

export const ButtonCancell = styled.button`
  width: 50%;
  padding: 24px 0;
  margin: 0 auto;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
  background-color: ${theme.colors.erro};
  border-radius: ${theme.border.mediumRadius};
`
